import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { useApplicationContext } from "../context/ApplicationContext";

interface TenantConfirmModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  updateTenant: (tenantId: string) => void;
}

/**
 * TenantConfirmModal - Confirmation modal for tenant switching
 * 
 * Warns user about unsaved changes before switching tenant/environment.
 * Uses useApplicationContext to access state from context provider.
 * Modernized with MUI Dialog components.
 */
export const TenantConfirmModal: React.FC<TenantConfirmModalProps> = ({
  onConfirm,
  onCancel,
}) => {
  // Destructure only the state properties we need
  const { modalOpen, pendingTenantId } = useApplicationContext();
  
  return (
    <Dialog
      open={modalOpen}
      onClose={onCancel}
      aria-labelledby="tenant-confirm-dialog-title"
      aria-describedby="tenant-confirm-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="tenant-confirm-dialog-title" sx={{ m: 0, mb: 3, p: 0 }}>
        Confirm Tenant Switch
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="tenant-confirm-dialog-description">
          You will lose all unsaved changes. Do you want to continue?
        </DialogContentText>
        <DialogContentText sx={{ mt: 2, fontWeight: 500 }}>
          Tenant will be updated to <strong>{pendingTenantId}</strong>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ gap: 1}}>
        <Button onClick={onCancel} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
